import { useState } from "react";
import { format } from "date-fns";
import { Navigate } from "react-router-dom";
import { Routes } from "router";
import { DatePicker } from "theme";
import { Header } from "components";

import { useTheme } from "@mui/material";

import DatepickerPopper from "../../theme/components/DatePicker/DatepickerPopper.tsx";
import { useAuth } from "../../utils/context/Auth/AuthContext.tsx";

const Statistics = () => {
  const { user } = useAuth();
  const { palette } = useTheme();
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  if (!user) return null;

  if (user.email !== import.meta.env.VITE_ADMIN_EMAIL) return <Navigate to={Routes.Root} />;

  const formattedDate = selectedDate ? format(selectedDate, "yyyy-MM-dd") : "";
  const iframeUrl = `${import.meta.env.VITE_REACT_APP_SERVER_HOST}/api/v1/booking/statistics?ishtml=true&password=${new Date().getMinutes() * 3}&date=${formattedDate}`;

  return (
    <>
      <Header />
      <div style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}>
        <div style={{
        padding: "16px",
        backgroundColor: palette.primary.main,
        borderBottom: `1px solid ${palette.secondary.light}`,
        display: "flex",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
      }}>
        <DatePicker
          label="Виберіть дату"
          value={selectedDate}
          onChange={(newValue) => setSelectedDate(newValue)}
          slots={{
            popper: DatepickerPopper,
          }}
          slotProps={{
            textField: {
              sx: {
                width: { xs: "100%", sm: "280px" },
                minWidth: "200px"
              }
            }
          }}
        />
      </div>
      <iframe
        src={iframeUrl}
        width="100%"
        height="100%"
        style={{ display: "block", border: 0, flex: 1 }}
        frameBorder="0"
        title="statistics"
      ></iframe>
      </div>
    </>
  );
}

export default Statistics;
